import '../../styles/SignInUp.css';
import { useLocation } from 'react-router-dom';

function EmailVerificationWindow() {
  const location = useLocation();
  const userEmail = location.state?.email || "adres e-mail";

  return (
    <div className="register-wrapper">
      <div className="register-card">
          <h3 className="register-title">
            Zmiana hasła
          </h3>
          <p className="register-subtitle">Aby przejść do formularza zmiany hasła, kliknij link który przyszedł na poniższy adres e-mail: <br />
            <span style={{ color: "red", fontSize: "small" }}>Uwaga! Jeśli podano e-mail nieistniejącego konta, to link nie zostanie wysłany</span></p>
          <strong style={{ "color": "#00E5FF", "fontSize": "large" }}>{userEmail}</strong>

        </div>
      </div>
      );
}

      export default EmailVerificationWindow;